import { render } from "./MonitorShare.vue?vue&type=template&id=01677446"
import script from "./MonitorShare.vue?vue&type=script&lang=js"
export * from "./MonitorShare.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__